<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-tooltip__popper {
  font-size: 14px;
  max-width: 50%;
  background: #4E5465 !important;
} /*设置显示隐藏部分内容，按50%显示*/
// .el-table .cell {
//   // 超出两行显示省略号
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 4;
//   -webkit-box-orient: vertical;
// }
</style>